import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalHeadline: {
    id: 'LoginModal.modal.headline',
    defaultMessage: 'Schnell anmelden',
  },
  login: {
    id: 'Login.label.login',
    defaultMessage: 'Anmelden',
  },
  emailPasswordTabTitle: {
    id: 'LoginModal.tabs.email-password.title',
    defaultMessage: 'E-Mail-Adresse & Passwort',
  },
  customerNoTabTitle: {
    id: 'LoginModal.tabs.customer_no-dateofbirth.title',
    defaultMessage: 'Kundennummer & Geburtsdatum',
  },
  captchaHeadline: {
    id: 'LoginContainer.CaptchaHeadline',
    defaultMessage: 'Sicherheitsüberprüfung',
  },
});
